export const DEFAULT_PAGE_SIZE = 10;

export const ROW_NUMBER_COLUMN_ID = 'row_number_column';

// arbitrary number that is usually smaller than the 300px max width of the cell
export const SMALL_TEXT_LENGTH = 35;

// Needed for virtualization. Matches value from Pivot table.
export const ROW_HEIGHT_PX = 34;
